<template>
  <div>
    <div class="audit-statistics-search">
      <el-form :inline="true" :model="queryForm" @submit.native.prevent>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="queryForm.timeRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :editable="false"
            style="width: 260px;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="机构名称">
          <el-input
            v-model="queryForm.licenseName"
            placeholder="请输入机构名称"
            clearable
            style="width: 220px;"
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="企业名称">
          <el-input
            v-model="queryForm.enterpriseName"
            placeholder="请输入企业名称"
            clearable
            style="width: 220px;"
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select
            v-model="queryForm.auditStatus"
            placeholder="请选择审核状态"
            clearable
            style="width: 160px;"
          >
            <el-option label="通过" value="通过"></el-option>
            <el-option label="待审核" value="待审核"></el-option>
            <el-option label="退回" value="退回"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%;"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          prop="licenseName"
          label="机构名称"
          min-width="200"
        >
          <template slot-scope="{ row }">
            <span>{{ row.licenseName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="total" label="总数" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.total }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="passedCount" label="通过总数" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.passedCount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="rejectedCount" label="退回总数" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.rejectedCount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pendingCount" label="待审核" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.pendingCount }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { selectAuditByOrganization } from "../../api/bankcrecenter.js";
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      queryForm: {
        timeRange: [],
        licenseName: "",
        enterpriseName: "",
        auditStatus: ""
      }
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    // 组装查询参数
    buildParams() {
      const params = {};
      if (this.queryForm.timeRange && this.queryForm.timeRange.length === 2) {
        params.startTime = this.queryForm.timeRange[0];
        params.endTime = this.queryForm.timeRange[1];
      }
      if (this.queryForm.licenseName) {
        params.licenseName = this.queryForm.licenseName;
      }
      if (this.queryForm.enterpriseName) {
        params.enterpriseName = this.queryForm.enterpriseName;
      }
      if (this.queryForm.auditStatus) {
        params.auditStatus = this.queryForm.auditStatus;
      }
      return params;
    },
    // 查询列表（纯展示，无分页）
    async fetchList() {
      this.loading = true;
      try {
        const res = await selectAuditByOrganization(this.buildParams());
        const data = res.data && res.data.data;
        this.tableData = Array.isArray(data)
          ? data
          : data && (data.records || data.list) || [];
      } catch (error) {
        this.tableData = [];
        this.$message.error("获取审核统计失败");
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.fetchList();
    },
    handleReset() {
      this.queryForm = {
        timeRange: [],
        licenseName: "",
        enterpriseName: "",
        auditStatus: ""
      };
      this.fetchList();
    }
  }
};
</script>

<style scoped>
.audit-statistics-search .el-form-item {
  margin-bottom: 10px;
}
</style>
